import { render, staticRenderFns } from "./LimitMemory.vue?vue&type=template&id=09fe3d90&scoped=true"
import script from "./LimitMemory.vue?vue&type=script&lang=js"
export * from "./LimitMemory.vue?vue&type=script&lang=js"
import style0 from "./LimitMemory.vue?vue&type=style&index=0&id=09fe3d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe3d90",
  null
  
)

export default component.exports